module.exports = __webpack_public_path__ + "img/pdt.e9ed4bc5.jpg";